/**
 * @import { InjectionKey } from 'vue';
 * @import { RadioButtonGroupContext } from './useRadioButtonGroupContext.types';
 */

import { provide, inject, computed } from 'vue';

/** @type {InjectionKey<RadioButtonGroupContext>} */
const radioButtonGroupSymbol = Symbol('kk-radio-button-group');

/**
 * @param {RadioButtonGroupContext} context
 */
export function useProvideRadioButtonGroupContext(context) {
  provide(radioButtonGroupSymbol, context);
}

export function useInjectRadioButtonGroupContext() {
  return inject(radioButtonGroupSymbol, {
    value: computed(() => null),
    size: computed(() => 'mg'),
    isDisabled: computed(() => false),
    onChange: () => {},
  });
}
